import { localStorage } from 'dibs-browser-storage';
import SV from 'server-vars';
import { getBuyerId } from 'dibs-cookie-jar';

import { fetchTradeOnboardingEligibility } from './fetchTradeOnboardingEligibility';
import {
    PDP_TRADE_DESIGN_MANAGER_ONBOARDING_VIEW_COUNT_STORAGE_KEY,
    PDP_TRADE_ONBOARDING_VIEW_COUNT_STORAGE_KEY,
    SB_TRADE_ONBOARDING_VIEW_COUNT_STORAGE_KEY,
} from './constants';

export function hasSeenPdpTradeDesignManagerOnboardingModal() {
    const timesShown =
        localStorage.getItem(PDP_TRADE_DESIGN_MANAGER_ONBOARDING_VIEW_COUNT_STORAGE_KEY) || 0;
    return timesShown > 0;
}

export function hasSeenPdpTradeOnboardingModal() {
    const timesShown = localStorage.getItem(PDP_TRADE_ONBOARDING_VIEW_COUNT_STORAGE_KEY) || 0;
    return timesShown > 0;
}

export function hasSeenSbTradeOnboardingModal() {
    const timesShown = localStorage.getItem(SB_TRADE_ONBOARDING_VIEW_COUNT_STORAGE_KEY) || 0;
    return timesShown > 0;
}

const tradeOnboardingRuleFactory = ({ hasSeen }) => ({ relayEnvironment }) => {
    const userId = getBuyerId(document.cookie);
    const isUserTypeTrade = SV.get('settings.isUserTypeTrade') || false;

    if (!userId || !isUserTypeTrade || hasSeen) {
        return Promise.resolve(false);
    }

    return fetchTradeOnboardingEligibility(relayEnvironment, userId);
};

export const pdpTradeDesignManagerOnboardingRule = tradeOnboardingRuleFactory({
    hasSeen: hasSeenPdpTradeDesignManagerOnboardingModal(),
});

export const pdpTradeOnboardingRule = tradeOnboardingRuleFactory({
    hasSeen: hasSeenPdpTradeOnboardingModal(),
});

export const sbTradeOnboardingRule = tradeOnboardingRuleFactory({
    hasSeen: hasSeenSbTradeOnboardingModal(),
});
